import React, { useState } from 'react'
import './styles.css'
import { Grid } from '@material-ui/core'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { Dialog } from 'components'

import { UserPoll } from '../../types'

interface UserPollOrderDialogProps {
  userPolls: UserPoll[]
  handleClose: () => void
  onUpdateOrder: (order: number[]) => void
}

// eslint-disable-next-line @typescript-eslint/member-delimiter-style
const SortableItem = ({ id, question }: { id: number; question: string }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: `poll_${id}`,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? '#e78923' : 'grey',
    padding: 16,
    margin: '0 0 8px 0',
    userSelect: 'none' as const,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {question}
    </div>
  )
}

const UserPollOrderDialog: React.FC<UserPollOrderDialogProps> = ({
  userPolls,
  handleClose,
  onUpdateOrder,
}) => {
  const [userPollList, setUserPollList] = useState(userPolls)

  const handleUpdateOrder = () => {
    onUpdateOrder(userPollList.map(el => el.id))
  }

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event
    if (!over || !userPollList) return

    if (active.id !== over.id) {
      const oldIndex = userPollList.findIndex(p => `poll_${p.id}` === active.id)
      const newIndex = userPollList.findIndex(p => `poll_${p.id}` === over.id)

      setUserPollList(arrayMove(userPollList, oldIndex, newIndex))
    }
  }

  return (
    <Dialog
      title="Ordenamiento"
      isOpen
      showActions
      onCancel={handleClose}
      okButtonText="Guardar"
      onAccept={handleUpdateOrder}
      hideCancelButton
    >
      <Grid container spacing={3} justify="center" alignItems="center">
        <Grid item xs={12}>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={userPollList.map(p => `poll_${p.id}`)}
              strategy={verticalListSortingStrategy}
            >
              {userPollList.map(poll => (
                <SortableItem key={poll.id} id={poll.id} question={poll.question} />
              ))}
            </SortableContext>
          </DndContext>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { UserPollOrderDialog }
